import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { format } from 'date-fns';
import axios from 'axios';

import ModalHeader from '../../../common/components/ModalHeader'

const CreateEditImmunizationModal = ({
  onHide,
  reload,
  selectedDose = null,
  show,
  testGroup,
  testGroupUser,
}) => {

  const [foundVaccines, setFoundVaccines] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedVaccine, setSelectedVaccine] = useState(null);
  const [vaccinatedAt, setVaccinatedAt] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [vaccineSearch, setVaccineSearch] = useState('');

  useEffect(() => {
    if (!!selectedDose) {
      setSelectedVaccine({
        cvx_code: selectedDose.cvx_code,
        name: selectedDose.name,
        description: selectedDose.description
      });
      if (!!selectedDose?.date) {
        setVaccinatedAt(
          format(new Date(selectedDose.date), 'yyyy-MM-dd')
        );
      }
    } else {
      setSelectedVaccine(null);
      setVaccinatedAt(format(new Date(), 'yyyy-MM-dd'));
    }
  }, [selectedDose]);

  useEffect(() => {
    if (vaccineSearch.length > 2) {
      setIsSearching(true);
      setSelectedVaccine(null);
      axios.get(`/vaccine_searches/query`, {
        params: { query: vaccineSearch }
      })
        .then(response => {
          setFoundVaccines(response.data.vaccine_searches);
          setIsSearching(false);
        })
        .catch(error => {
          console.error('Error searching vaccines:', error);
          setIsSearching(false);
        });
    } else {
      setFoundVaccines([]);
    }
  }, [vaccineSearch]);

  const handleDelete = async () => {
    const response = await axios.delete(
      `/test_groups/${testGroup.slug}/immunizations/${testGroupUser.id}/vaccine_histories/${selectedDose.id}`,
    );

    reload();
    onHide();
  };

  const handleSave = async () => {
    if (!selectedVaccine) return;

    setIsSaving(true);
    try {
      const body = {
        cvx_code: selectedVaccine.cvx_code,
        vaccine: selectedVaccine.name,
        valid_dose: true,
        source: 'upload',
        vaccinated_at: vaccinatedAt,
        vaccine_history_id: selectedDose,
      };

      if (!selectedDose) {
        await axios.post(`/test_groups/${testGroup.slug}/immunizations/${testGroupUser.id}`, {
          vaccine_history: body,
        });
      } else {
        await axios.put(`/test_groups/${testGroup.slug}/immunizations/${testGroupUser.id}/vaccine_histories/${selectedDose.id}`, {
          vaccine_history: body,
        });
      }

      reload();
      onHide();
    } catch (error) {
      console.error(`Error ${!selectedDose ? 'creating' : 'updating'} vaccine history:`, error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <ModalHeader closeButton onHide={onHide}>
        <Modal.Title>{!selectedDose ? 'Add vaccine dose' : 'Edit vaccine dose'}</Modal.Title>
      </ModalHeader>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Search vaccine</Form.Label>
            <Form.Control
              value={vaccineSearch}
              placeholder="Search and select a vaccine"
              onChange={(e) => setVaccineSearch(e.target.value)}
            />
          </Form.Group>

          {isSearching && <div className="text-muted">Loading...</div>}

          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {selectedVaccine ? (
              <div
                className="py-3 my-3 pointer bg-light"
                onClick={() => setSelectedVaccine(null)}
              >
                <h4 className="font-weight-normal px-2">{selectedVaccine.name}</h4>
                <div className="text-muted px-2">{selectedVaccine.description}</div>
              </div>
            ) : (
              foundVaccines.map((vaccine) => (
                <div
                  key={vaccine.cvx_code}
                  className="py-3 pointer border-bottom"
                  onClick={() => setSelectedVaccine(vaccine)}
                >
                  <h4 className="font-weight-normal">{vaccine.name}</h4>
                  <div className="text-muted">{vaccine.description}</div>
                </div>
              ))
            )}
          </div>

          {selectedVaccine && (
            <Form.Group className="mb-3">
              <Form.Label>Vaccination date</Form.Label>
              <Form.Control
                type="date"
                value={vaccinatedAt}
                onChange={(e) => setVaccinatedAt(e.target.value)}
              />
            </Form.Group>
          )}
          {!!selectedDose && (
            <div className="text-end mt-3">
              <Button
                className="text-danger"
                variant="link"
                onClick={handleDelete}
              >
                Delete
              </Button>
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!selectedVaccine || isSaving}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateEditImmunizationModal; 